<template>
  <div class="card p-4 mt-3">
    <div class="recently-viewed">
      <div class="pro-viewed-list">
        <h4 class="border-bottom border-1 pb-2 mb-4">
          Recently Viewed Products
        </h4>
        <div
          class="row row-cols-2 row-cols-md-6 row-cols-lg-6 row-cols-xl-6 gx-2"
        >
          <div
            class="col"
            v-for="recently in recentlyViewed"
            :key="recently.id"
          >
            <div class="product-card border-0">
              <div class="card-body">
                <div class="pro-img-block">
                  <div v-lazy-container="{ selector: 'img' }">
                    <img
                      :data-src="set_image(recently.product.photo)"
                      class="card-img-top pro-img"
                      :alt="recently.product.name"
                      data-error="assets/images/no_image.svg"
                      data-loading="assets/images/loading.gif"
                    />
                  </div>
                </div>
                <div class="pro-short-desc pro-link">
                  {{ recently.product.name }}
                </div>
                <span class="pro-model"
                  >Model:
                  <strong>{{ recently.product.description }}</strong></span
                >
                <h6 class="pro-price"> 
                
                    {{
                                CalculateProductSellPrice(recently.price, recently.discount, recently.product_admin_markup_amount, recently.contractor_products[0].markup, recently.box_sqft, (recently.product && recently.product.category && recently.product.category.unit) ? recently.product && recently.product.category && recently.product.category.unit : '')|toCurrency
                            }}
                </h6>
                <!--                                <div class="star-rated">-->
                <!--                                    <span class="star-rating" style="width: 04.3034em;"></span>-->
                <!--                                </div>-->

                <div class="pro-shipping">
                  <span
                    >
                    <span style="transform: rotateY(180deg);"><i class="fa fa-truck " aria-hidden="true"></i></span>
                    <span>FREE Shipping / Pickup</span>
                    </span
                  >
                </div>
              </div>
              <router-link
                :to="`/product/${str_encode(recently.id)}`"
                class="stretched-link"
              ></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["recentlyViewed"],
  methods:{
        CalculateProductSellPrice(Price, Discount, ProductAdminMarkupAmount, ContractorMarkup, box_sqft = 0, unit = '') {
            Price = parseFloat(Price);
            Discount = parseFloat(Discount);
            ProductAdminMarkupAmount = parseFloat(ProductAdminMarkupAmount);
            ContractorMarkup = parseFloat(ContractorMarkup);
            let product_price = (Price - (Price * Discount / 100)) + ProductAdminMarkupAmount;
            let contractor_markup = product_price * ContractorMarkup / 100;
            //let admin_markup = ProductAdminMarkupAmount
            let sell_price = product_price + contractor_markup;
            //return sell_price.toFixed(2);

            return unit == 'Box' ? (sell_price / box_sqft) : sell_price;
        },
    }
};
</script>
